export default "__VITE_ASSET__aM98zzwf__"